import { atom } from 'recoil';

const selectedContact = atom({
    key: 'selectedContact',
    default: {}
});

export {
    selectedContact
};